export default __webpack_public_path__ + "static/media/SWT0040.34I-29939_-23343_0.2e93dcd2.jpg";